import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { PageHeader } from "@/components/UI";
import { StockTab } from "@/components/stock/StockTab";
import { LotsTab } from "@/components/stock/LotsTab";

const tabCls = ({ isActive }) =>
  `px-4 py-2 text-sm font-medium border-b-2 transition-colors ${isActive ? "border-indigo-600 text-indigo-700" : "border-transparent text-slate-500 hover:text-slate-800"}`;

export default function StockPage() {
  const lots = useLocation().pathname.startsWith("/stock/lots");
  return (
    <div data-testid="stock-page">
      <PageHeader title="Stok" description="Kalan Stok = Mevcut Stok − Rezerve Stok" />
      <div className="flex gap-1 border-b border-slate-200 mb-4">
        <NavLink end to="/stock" className={tabCls} data-testid="stock-tab-link">Stok Özeti</NavLink>
        <NavLink to="/stock/lots" className={tabCls} data-testid="lots-tab-link">Lotlar</NavLink>
      </div>
      {lots ? <LotsTab /> : <StockTab />}
    </div>
  );
}
